import React, { Component } from "react";
import { connect } from "react-redux";
import Score from './Score';
// import RageClickMeter from "./RageClickMeter";
import {
	gameMusic,
	fadeMusic,
	toggleMute
} from "./../../actions/actionCreators.js";

const mapStateToProps = state => {
	const g = state.game;
	return {
		score: g.score,
		mute: g.mute,
		time: g.time
	};
};

const mapDispatchToProps = dispatch => {
	return {
		gameMusic: () => dispatch(gameMusic()),
		fadeMusic: () => dispatch(fadeMusic()),
		toggleMute: () => dispatch(toggleMute())
	};
};

class HudContainer extends Component {
	muteToggle = e => {
		e.preventDefault();
		this.props.toggleMute();
	};

	render() {
		const {countdown, hideScore} = this.props;
		
		return (
			<div className="hud">
				<div className="topright">
					<div
						className="mute"
						onClick={() => this.props.toggleMute()}
					>
						{/* <svg version="1.1" id="mute" viewBox="0 0 27.404 27.404" enableBackground="new 0 0 27.404 27.404">
							<circle fill="#FFFFFF" cx="13.702" cy="13.702" r="13.702"/>
							<polygon fill="#4B5763" points="11.836,6.517 9.384,9.901 4.407,11.127 4.407,16.025 9.384,17.251 11.836,20.636 12.727,20.636 
								12.727,6.517 "/>
							<polygon id="noaudio" className={`${this.props.mute ? "show" : "hide"}`} fill="#D30505" points="22.997,16.239 20.334,13.576 22.997,10.913 21.782,9.698 19.119,12.361 16.456,9.698 
								15.241,10.913 17.904,13.576 15.241,16.239 16.456,17.454 19.119,14.791 21.782,17.454 "/>
						</svg> */}
						<svg version="1.1" id="mute" x="0px" y="0px" viewBox="0 0 27.404 27.404" enableBackground="new 0 0 27.404 27.404">
							<circle fill="#FFFFFF" cx="13.702" cy="13.702" r="13.702"/>
							<polygon fill="#4B5763" points="11.836,6.517 9.384,9.901 4.407,11.127 4.407,16.025 9.384,17.251 11.836,20.636 12.727,20.636 
								12.727,6.517 "/>
							<polygon id="noaudio" className={`${this.props.mute ? "show" : "hide"}`} fill="#D30505" points="22.997,16.239 20.334,13.576 22.997,10.913 21.782,9.698 19.119,12.361 16.456,9.698 
								15.241,10.913 17.904,13.576 15.241,16.239 16.456,17.454 19.119,14.791 21.782,17.454 "/>
							<g id="audioon" className={`${this.props.mute ? "hide" : "show"}`}>
								<path fill="#4B5763" d="M16.207,19.209l-1.414-1.414C14.834,17.751,16,16.491,16,13.702c0-2.79-1.167-4.05-1.216-4.102l1.423-1.405
									C16.28,8.268,18,10.03,18,13.702S16.28,19.136,16.207,19.209z"/>
								<path fill="#4B5763" d="M19.753,22.111l-1.414-1.414c0.081-0.084,2.114-2.236,2.114-6.995s-2.033-6.911-2.12-7l1.419-1.409
									c0.11,0.11,2.7,2.764,2.7,8.409C22.454,19.347,19.864,22.001,19.753,22.111z"/>
							</g>
						</svg>
					</div>
					{ hideScore !== true &&
						<Score
							score={this.props.score}
						/> 
					}
				</div>
				{ countdown !== undefined &&
					<div className="time">
						<div className="skew">
							<span 
								className={`${((countdown <= 10) && (countdown > 0))  ? 'pulse' : ''}`}>{`${countdown > 0 ? Math.floor(countdown) : 0}`}</span>
						</div>
					</div>
				}
			</div>
		);
	}
}

const Hud = connect(mapStateToProps, mapDispatchToProps)(HudContainer);
export default Hud;



// WEBPACK FOOTER //
// ./src/components/hud/Hud.js